const config = {
	api: '//api.impartiality.online',
	//api: 'http://ir.wezom.agency',
	//api: 'http://ir-api.loc',
};

export default config;
